export const whiteLocaleList = ['jp', 'eu', 'uk', 'de', 'fr', 'it', 'es', 'us', 'ca']; //白名单
export const productPageUrl = 'rapid-mag-power-bank';
export const productPageTheme = 'white'; //主题色
export const generalKey = ['rapid_mag_504_5k', 'rapid_mag_504_10k'];
export const GeneralKeys = ['rapid_mag_504_5k', 'rapid_mag_504_10k', 'product_rapid'];

export const GeneralKeys_JP_V2_StatusC = ['rapid_mag_510_10k', 'rapid_mag_504_5k', 'rapid_mag_504_10k'];
export const GeneralKeys_JP_V2_StatusD = ['EcoFlow RAPID Mag Power Bank', 'rapid_mag_510_10k', 'rapid_mag_504_5k', 'rapid_mag_504_10k'];
export const generalKey_na = ['rapid_mag_510_10k', 'EcoFlow RAPID Mag Power Bank', 'rapid_mag_pb020', 'rapid_mag_504_10k'];
